import { useTranslation } from "react-i18next";
import { Link, type Location } from "react-router";
import cn from "classnames";
import type { SidebarLink } from "./types";

export default function SidebarLinkItem({
  item,
  location,
  isCollapsed,
}: {
  item: SidebarLink;
  location: Location;
  isCollapsed?: boolean;
}) {
  const Icon = item.icon;
  const isActive = location.pathname === item.href;
  const { t } = useTranslation("Sidebar");
  const badge = item.badge;

  return (
    <Link
      to={item.carryFrom ? `${item.href}?from=${encodeURIComponent(location.pathname)}` : item.href}
      onClick={item.onClick}
      title={isCollapsed ? t(item.label) : undefined}
      className={cn(
        "group flex items-center py-1.5 rounded-lg cursor-pointer transition-[padding] duration-300 outline-none focus-visible:ring-2 focus-visible:ring-brand-200",
        isActive
          ? "text-body-bold-sm bg-brand-500/15 content-base-primary"
          : "text-body-regular-sm content-base-primary hover:bg-brand-500/15",
        isCollapsed ? "justify-center" : "gap-2 px-2",
      )}>
      <span className={cn("relative shrink-0", isActive && "content-action-brand")}>
        {Icon && <Icon size={16} variant={isActive ? "Bulk" : "Linear"} color="currentColor" />}
        {badge != null && badge > 0 && (
          <span
            className={cn(
              "items-center justify-center rounded-full text-[10px] font-semibold background-negative-fill text-white transition-opacity duration-300",
              isCollapsed
                ? "absolute -top-1.5 -right-2.5 min-w-4 h-4 px-0.5 flex"
                : "hidden",
            )}>
            {badge}
          </span>
        )}
      </span>
      <span
        className={cn(
          "whitespace-nowrap overflow-hidden transition-[opacity,width] duration-300",
          isCollapsed ? "opacity-0 w-0" : "opacity-100",
        )}>
        {t(item.label)}
      </span>
      {badge != null && badge > 0 && (
        <span
          className={cn(
            "min-w-4 h-4 px-1 items-center justify-center rounded-sm text-[10px] font-semibold background-negative-fill text-white transition-opacity duration-300",
            isCollapsed ? "hidden" : "ml-auto flex",
          )}>
          {badge}
        </span>
      )}
    </Link>
  );
}
